<mwe-form
  (formIsInvalid)="handleFormValidation($event)"
  (formIsValid)="handleFormValidation($event)"
  [formModel]="formModel"
  id="mwe-new-client-personal-details-form"
/>
